import { AuthStore } from 'types';
import { initState } from './initState';
import { actions } from './actions';
import { thunks } from './thunks';

export const auth: AuthStore = {
  ...initState,
  ...actions,
  ...thunks,
};
